import firebase from 'firebase/app'
import 'firebase/database'
// import {reportEvent} from "@/helpers/utils";


const firebaseConfig = {
  apiKey: "AIzaSyB5-sD4COvprCiHFqrDwyFOUsam1GI7QMs",
  authDomain: "kids-mode-app.firebaseapp.com",
  databaseURL: "https://kids-mode-app-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kids-mode-app",
  storageBucket: "kids-mode-app.appspot.com",
  messagingSenderId: "846238683911",
  appId: "1:846238683911:web:5d7aa208f43b5fabfb6ba2",
  measurementId: "G-SET3HHQHJK"
};

firebase.initializeApp(firebaseConfig)
export const db = firebase.database()


